import http from '@/utils/http/index';

export function getPaySafeConfig(params) {
  return http.get('/paySafe/getPaymentConfig', { params });
}

export function updatePaySafeConfig(params) {
  return http.get('/paySafe/updatePaymentConfig', { params });
}

export function getPhoneCaptcha(data) {
  return http.post('/paySafe/getPhoneCaptcha', data);
}

export function updatePayPassword(data) {
  return http.post('/paySafe/updatePayPassword', data);
}
